import React from 'react'
import { MdFormatBold } from '@react-icons/all-files/md/MdFormatBold'
import { MdFormatItalic } from '@react-icons/all-files/md/MdFormatItalic'
import { MdFormatUnderlined } from '@react-icons/all-files/md/MdFormatUnderlined'
import { MdFormatListBulleted } from '@react-icons/all-files/md/MdFormatListBulleted'
import { MdFormatListNumbered } from '@react-icons/all-files/md/MdFormatListNumbered'
import { MdFormatAlignLeft } from '@react-icons/all-files/md/MdFormatAlignLeft'
import { MdFormatAlignCenter } from '@react-icons/all-files/md/MdFormatAlignCenter'
import { MdFormatAlignRight } from '@react-icons/all-files/md/MdFormatAlignRight'
import { MdLink } from '@react-icons/all-files/md/MdLink'
import { MdLinkOff } from '@react-icons/all-files/md/MdLinkOff'
import { MdEdit } from '@react-icons/all-files/md/MdEdit'
import { MdImage } from '@react-icons/all-files/md/MdImage'
import { MdAlternateEmail } from '@react-icons/all-files/md/MdAlternateEmail'
import { MdSend } from '@react-icons/all-files/md/MdSend'
import { MdAccessTime } from '@react-icons/all-files/md/MdAccessTime'
import { MdTimer } from '@react-icons/all-files/md/MdTimer'
import { MdSmartButton } from '@react-icons/all-files/md/MdSmartButton'
import { MdCloudUpload } from '@react-icons/all-files/md/MdCloudUpload'
import { MdDataObject } from '@react-icons/all-files/md/MdDataObject'
import { MdFormatColorText } from '@react-icons/all-files/md/MdFormatColorText'
import { MdFormatColorFill } from '@react-icons/all-files/md/MdFormatColorFill'
import styles from './toolbar.module.css'

export const BoldIcon = MdFormatBold
export const ItalicIcon = MdFormatItalic
export const UnderlineIcon = MdFormatUnderlined
export const BulletListIcon = MdFormatListBulleted
export const OrderedListIcon = MdFormatListNumbered
export const AlignLeftIcon = MdFormatAlignLeft
export const AlignCenterIcon = MdFormatAlignCenter
export const AlignRightIcon = MdFormatAlignRight
export const LinkIcon = MdLink
export const UnlinkIcon = MdLinkOff
export const EditIcon = MdEdit
export const ImageIcon = MdImage
export const AtIcon = MdAlternateEmail
export const SendIcon = MdSend
export const TimestampIcon = MdAccessTime
export const TimeRangeIcon = MdTimer
export const CtaIcon = MdSmartButton
export const UploadIcon = MdCloudUpload
export const MergeTagIcon = MdDataObject

export function TextColorIcon({ color }: { color?: string }) {
  return (
    <span className={styles.colorIconWrapper}>
      <MdFormatColorText />
      <span
        className={styles.colorIndicator}
        // eslint-disable-next-line react/forbid-dom-props
        style={{ backgroundColor: color || 'transparent' }}
      />
    </span>
  )
}

export function BgColorIcon({ color }: { color?: string }) {
  return (
    <span className={styles.colorIconWrapper}>
      <MdFormatColorFill />
      <span
        className={styles.colorIndicator}
        // eslint-disable-next-line react/forbid-dom-props
        style={{ backgroundColor: color || 'transparent' }}
      />
    </span>
  )
}
